<template>
    <div class="header">
        <div>
            <div class="tutorial">

                <!-- BR já tem os vídeos. O resto do mundo ainda não -->
                <div class="options">
                    <a @click="handleVideo(1)" v-html="t.title_video_1"></a>
                    <a @click="handleVideo(2)" v-html="t.title_video_2"></a>
                    <a v-if="allData.data.lang == 'br'" @click="handleVideo(3)" v-html="t.title_video_3"></a>
                    <a @click="handleVideo(4)" v-html="t.title_video_4"></a>
                    <a @click="handleVideo(5)" v-html="t.title_video_5"></a>
                </div>

                <!--
                <div class="options" v-else>
                    <a class="helper__tooltip no-icon">
                        <span v-html="t.title_video_1" style="font-size: inherit;"></span>
                        <span class="helper__tooltip--text" v-text="comming_soon"></span>
                    </a>
                    <a class="helper__tooltip no-icon" >
                        <span v-html="t.title_video_2" style="font-size: inherit;"></span>
                        <span class="helper__tooltip--text" v-text="comming_soon"></span>
                    </a>
                    <a class="helper__tooltip no-icon" >
                        <span v-html="t.title_video_3" style="font-size: inherit;"></span>
                        <span class="helper__tooltip--text" v-text="comming_soon"></span>
                    </a>
                    <a class="helper__tooltip no-icon" >
                        <span v-html="t.title_video_4" style="font-size: inherit;"></span>
                        <span class="helper__tooltip--text" v-text="comming_soon"></span>
                    </a>
                    <a class="helper__tooltip no-icon" >
                        <span v-html="t.title_video_5" style="font-size: inherit;"></span>
                        <span class="helper__tooltip--text" v-text="comming_soon"></span>
                    </a>
                </div>
            -->

                <div class="video">
                    <div class="container__youtube">
                        <iframe
                            ref="jsIframe"
                            :src="allData.url_video_rank['0']"
                            frameborder="0"
                            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                            allowfullscreen
                        ></iframe>
                        <!-- <img v-else src="/internacional/public/office4/img/soon/ic-soon.png" style="width: 100%"> -->
                    </div>
                </div>

            </div>
            <br />
            <!--
            <div class="tagline card-v4">
                <div class="box__left">
                    <span class="helper__tooltiptestepopup v4">
                        <h3 v-html="t.title_video_5">CONGRATULATIONS</h3>
                        <span
                            class="helper__tooltip--text"
                            v-html="t.dash_business_tooltip_requested"
                        ></span>
                    </span>
                    <h4 v-html="t.sub_sentence_tagline"></h4>
                </div>
                <div class="box__right">
                    <h2>{{allData.points_affiliation_sells}}pts</h2>
                    <div class="progress-bar">
                        <div class="bar" v-bind:class="{ 'bigger': allData.points_affiliation_sells > 0, '' : allData.points_affiliation_sells == 0 }"></div>
                    </div>
                </div>
            </div>
            -->
        </div>
        <!--
        <div class="banner">
            <span v-html="t.label_title_banner_rank"></span>
            <a class="calculator" :href="this.allData.urls['rota_calculadora']" target="_blank" v-html="t.label_see_calculator"></a>
            <h4 v-html="t.label_body_1_banner_rank"></h4>
            <span v-html="t.label_body_2_banner_rank"></span>
            <a class="learn__more" href="" target="_blank" v-html="t.label_learn_more"></a>
        </div>
        -->
    </div>
</template>

<script>
export default {
    name: "header-page-v3",
    props: ["translation"],
    data() {
        return {
            t: this.$parent.view.translation.header,
            allData: this.$parent.view.propsNewIndex,
            comming_soon: this.$parent.view.translation.coming_soon
        };
    },
    mounted() {
        // console.log(this.$parent.view.propsNewIndex);
        // console.log(this.$parent.view.translation);
    },
    methods: {
        handleVideo(data) {
            if (data == 1)
                this.$refs.jsIframe.src = this.allData.url_video_rank["1"];
            if (data == 2)
                this.$refs.jsIframe.src = this.allData.url_video_rank["2"];
            if (data == 3)
                this.$refs.jsIframe.src = this.allData.url_video_rank["3"];
            if (data == 4)
                this.$refs.jsIframe.src = this.allData.url_video_rank["4"];
            if (data == 5)
                this.$refs.jsIframe.src = this.allData.url_video_rank["5"];
        }
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.header {
    // display: grid;
    // grid-template-columns: 3fr 1fr;
    // grid-column-gap: 10px;
    .tutorial {
        display: grid;
        grid-template-columns: auto 1fr;
        background: var(--theme-color-primary);
        border-radius: 4px;
        .video {
            padding: 0.8rem 3.5rem;
            background: var(--theme-color-primary-light);
            border-radius: 4px 0 0 4px;
            .container__youtube {
                border-radius: 4px;
            }
        }
        .options {
            background: var(--theme-color-primary);
            border-radius: 0px 4px 4px 0px;
            padding: 0.8rem 3rem;
            display: flex;
            min-height: 330px;
            flex-direction: column;
            justify-content: space-evenly;
            a {
                text-align: center;
                font-weight: bold;
                font-size: 0.8rem;
                background: white;
                color: var(--theme-color-accent);
                padding: 1.1rem 1rem;
                border-radius: 4px;
                transition: 0.2s all;
                margin-bottom: 0.5rem;
                &:hover {
                    box-shadow: 0 0 17px -2px white;
                }
            }
        }
    }
    .tagline {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 0;
        .box__left {
            .helper__tooltip h3 {
                color: var(--theme-color-primary);
            }
            h4 {
                color: #818a91;
            }
        }
        .box__right {
            width: 120px;
            text-align: center;
            h2 {
                font-weight: bold;
                color: var(--theme-color-primary);
                font-size: 2.2rem;
            }
            .progress-bar {
                background: #e5e5e5;
                border-radius: 100px;
                height: 21px;
                position: relative;
                width: 100%;
                .bar {
                    position: absolute;
                    background: rgba(126, 26, 253, 0.8);
                    border-radius: 100px;
                    height: 21px;
                    &.bigger {
                        width: 40%;
                    }
                }
            }
        }
    }
    /*
    .banner {
        background: var(--theme-color-primary);
        color: white;
        display: flex;
        text-align: center;
        flex-direction: column;
        padding: 1rem .5rem 0 .5rem;
        border-radius: 5px;
        .calculator {
            color: white;
            text-decoration: underline;
            margin: 1rem .8rem;
        }
        h4 {
            font-size: 1.25rem;
            line-height: 25px;
            margin-bottom: 1.1rem;
        }
        .learn__more {
            background: white;
            color: #818A91;
            font-weight: bold;
            padding: 1.5rem 1rem;
            border-radius: 5px;
            margin: 1.5rem 0 1rem 0;
            text-transform: uppercase;
        }
    }
    */
}
@media (max-width: 1170px) {
    .header .tutorial .options,
    .video {
        padding: 0.8rem !important;
    }
}
@media (max-width: 1080px) {
    .header {
        .tutorial {
            grid-template-columns: 1fr;
        }
        .banner {
            margin-top: 1rem;
        }
        .tagline {
            flex-direction: column;
        }
    }
}
</style>


// WEBPACK FOOTER //
// resources/office/js/components/franchise_v4/rank/components/header.vue